import React, { useState, useEffect } from 'react';
import { Main } from './StyledComponents';
import { Head } from './components/Head';
import { Body } from './components/Body';
import { scrollToElement } from '../../utils/scrollToElement';
import { NoIssues } from './components/NoIssues';
export const AccessibilityChecker = ({
  data,
  onClose,
  isVisible
}) => {
  if (!data || !isVisible) return '';
  if (!data.length) {
    return /*#__PURE__*/React.createElement(NoIssues, {
      onClose: onClose
    });
  }
  const [selectedIssue, setSelectedIssue] = useState(0);
  const handlePrevious = () => setSelectedIssue(Math.max(selectedIssue - 1, 0));
  const handleNext = () => setSelectedIssue(Math.min(selectedIssue + 1, data.length - 1));
  useEffect(() => {
    if (!data[selectedIssue]) {
      setSelectedIssue(0);
    }
  }, [data]);
  useEffect(() => {
    if (data[selectedIssue]) {
      scrollToElement(data[selectedIssue].selector);
    }
  }, [selectedIssue]);
  if (!data[selectedIssue]) return '';
  return /*#__PURE__*/React.createElement(Main, null, /*#__PURE__*/React.createElement(Head, {
    data: data[selectedIssue],
    onClose: onClose,
    onPrev: handlePrevious,
    onNext: handleNext,
    count: {
      current: selectedIssue + 1,
      total: data.length
    }
  }), /*#__PURE__*/React.createElement(Body, {
    data: data[selectedIssue]
  }));
};